import React, {Component} from 'react';
import {
    Button,
    InputLabel,
    Tab,
    Tabs,
    TextField,
    withStyles,
    ExpansionPanel,
    ExpansionPanelDetails,
    ExpansionPanelSummary,
    Typography,
    DialogActions,
    DialogContent,
    DialogTitle,
} from 'material-ui';
import Select from 'react-select';
import classNames from 'classnames';
import DropzoneImageField from '../../../../components/fields/field_dropzone_image';
import {EditDialog} from '../../../../components/edit-dialog/edit_dialog';
import ImageDetailsCropDialog from '../image_details_crop';
import ImageDetailsMetaDialog from '../image_details_meta';
import {b64toBlob, toDataUrl} from '../../../../components/helpers/helpers';
import {urlRegex} from '../../../../components/helpers/constants';
import {TabContainer} from '../../../../components/tab/tab_container';
import SortableImageList from '../sortable_image_list';
import {styles} from '../../style/text_section';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';
import ImageSettings from '../image_settings';
import VideoSettings from '../video_settings';
import SimpleEditor from '../../../../components/editor/simple_editor';

export class TextSectionEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expandedImageSettings: false,
            expandedVideoSettings: false,
            openCropPopup: false,
            openImageMetaPopup: false,
            imageToCrop: null,
            imageToView: null,
            src: null,
            imageIndex: null,
            cropResult: null,
            cropRatioId: null,
            thumbCropResult: null,
            valueTab: 0,
            imageMeta: {
                title: '',
                alt: '',
                name: '',
                description: '',
                link: '',
            },
            errorUrl: false,
        };
    }

    onImageClick = (image, index) => {
        if (image.new) {
            this.updateLocalStateWithSectionImages(
                image,
                index,
                this.props.images
            );
            let croppedImage = this.props.images[index].croppedImage;
            let croppedImageThumb = this.props.images[index].croppedImageThumb;
            if (croppedImage) {
                toDataUrl(croppedImage, (cropUrl) => {
                    this.setCroppedImageInState(cropUrl);
                });
            }
            if (croppedImageThumb) {
                toDataUrl(croppedImageThumb, (cropUrl) => {
                    this.setThumbCroppedImageInState(cropUrl);
                });
            }
        } else {
            const {title, alt, name, description, link} = this.props.images[
                index
            ];
            this.setState({
                openCropPopup: true,
                openImageMetaPopup: true,
                imageToCrop: null,
                imageToView: image,
                imageIndex: index,
                imageMeta: {
                    title,
                    alt,
                    name,
                    description,
                    link,
                },
            });
        }
    };

    handleTabChange = (event, value) => {
        this.setState({
            valueTab: value,
        });
    };

    updateLocalStateWithSectionImages(image, index, images) {
        const {title, alt, name, description, link} = images[index];
        this.setState({
            openCropPopup: true,
            imageToCrop: image,
            imageIndex: index,
            imageMeta: {
                title,
                alt,
                name,
                description,
                link,
            },
        });
    }

    setThumbCroppedImageInState(croppedImage) {
        this.setState({
            thumbCropResult: croppedImage,
        });
    }

    setCroppedImageInState(croppedImage) {
        this.setState({
            cropResult: croppedImage,
        });
    }

    updateState() {
        this.setState({
            openCropPopup: false,
            openImageMetaPopup: false,
            imageToCrop: null,
            imageIndex: null,
            src: null,
            cropResult: null,
            cropRatioId: null,
            thumbCropResult: null,
            imageMeta: {
                title: '',
                alt: '',
                name: '',
                description: '',
                link: '',
            },
        });
    }

    render() {
        let {
            images,
            videos,
            open,
            title,
            body,
            instructions,
            onUpdateImagesField,
            onUpdateImagesSortOrder,
            onDeleteImageField,
            onHandleRequestClose,
            onUpdateTitleField,
            onUpdateInstructionsField,
            onUpdateVideoUrlField,
            onUpdateBodyField,
            onHandleRequestDone,
            onCropImage,
            onCropThumbImage,
            onImageMetaUpdate,
            onImageCropRatioUpdate,
            classes,
            sectionSettings,
            selectedSectionSettings,
            selectSectionSetting,
            imageSettings,
            selectedImageSettings,
            selectImageSetting,
            videoSettings,
            selectedVideoSettings,
            selectVideoSetting,
            sectionTypeText,
            textSectionId,
        } = this.props;

        images = images || [];

        const {valueTab} = this.state;

        let changeOrderTabProps = {
            disabled: false,
        };

        if (images.length < 2) {
            changeOrderTabProps.disabled = true;
        }

        let visibleImages = images.filter((image) => image.deleted === false);

        let currentSection = sectionTypeText.filter(
            (section) => section.uniqueId === textSectionId
        )[0];
        let isIntro = false;

        if (currentSection !== undefined) {
            isIntro = currentSection.placeholder_name.startsWith('Intro');
        }

        let error = false;

        let hasError = (selected) => {
            if (selected === null) {
                return (error = true);
            }

            if (selected.length < 17) {
                return (error = true);
            }

            return error;
        };

        let bodyHasError = classNames(
            isIntro && hasError(body) && classes.hasErrors
        );

        let videosArray =
            videos === undefined || videos.length < 1
                ? [{id: 0, url: ''}]
                : videos;

        const collapsibleSetting = sectionSettings.find(
            (setting) => setting.machine_name === 'section-collapse'
        );
        const selectedCollapseSetting = selectedSectionSettings.find(
            (setting) => setting.machine_name === 'section-collapse'
        );
        const selectedCollapseOptionId = selectedCollapseSetting
            ? selectedCollapseSetting.options[0].id
            : '';

        return (
            <div>
                <EditDialog
                    open={open}
                    classes={{
                        paper: classes.paper,
                        fullWidth: classes.fullWidth,
                    }}
                >
                    <DialogTitle>Edit Text Section</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="title"
                            label="Title"
                            onChange={(event) => {
                                onUpdateTitleField(event.target.value);
                            }}
                            fullWidth
                            value={title || ''}
                        />

                        <InputLabel
                            className={classNames(
                                bodyHasError,
                                'simpleEditorLabelPages'
                            )}
                        >
                            {isIntro ? 'Body *' : 'Body'}
                        </InputLabel>

                        <SimpleEditor
                            initialValue={body}
                            onChange={(htmlBody) => {
                                onUpdateBodyField(htmlBody);
                            }}
                        />

                        {isIntro ? (
                            hasError(body) ? (
                                <Typography variant="caption" color="error">
                                    Please fill in the introduction body!
                                </Typography>
                            ) : (
                                <Typography variant="caption">
                                    Type introduction body (at least 10
                                    characters)
                                </Typography>
                            )
                        ) : (
                            ''
                        )}

                        <Typography align="center" color="error">
                            Note: If the Video Url field is filled in, only the
                            video will be displayed on the page. No photos will
                            be displayed.
                        </Typography>

                        {images.length > 1 && (
                            <Typography
                                align="center"
                                className={classes.galleryError}
                            >
                                Note: In order to upload multiple images to
                                create a gallery all crop images must have the
                                same ratio of 9:5!
                            </Typography>
                        )}

                        <Tabs
                            value={valueTab}
                            indicatorColor="primary"
                            textColor="primary"
                            onChange={this.handleTabChange}
                        >
                            <Tab value={0} label="Upload Images" />
                            {visibleImages.length > 1 && (
                                <Tab
                                    value={1}
                                    label="Change Images Order"
                                    {...changeOrderTabProps}
                                />
                            )}
                        </Tabs>

                        {valueTab === 0 && (
                            <TabContainer>
                                <DropzoneImageField
                                    multiple={true}
                                    images={images}
                                    onImageDelete={(image, index) => {
                                        onDeleteImageField(image, index);
                                    }}
                                    onImageClick={this.onImageClick.bind(this)}
                                    onImagesDrop={(images) => {
                                        onUpdateImagesField(images);
                                    }}
                                />
                            </TabContainer>
                        )}
                        {valueTab === 1 && (
                            <TabContainer>
                                <SortableImageList
                                    items={visibleImages}
                                    onImagesSortOrder={(images) => {
                                        onUpdateImagesSortOrder(images);
                                    }}
                                />
                            </TabContainer>
                        )}

                        {images.length > 0 && visibleImages.length > 0 && (
                            <ExpansionPanel
                                style={{marginTop: '10px'}}
                                expanded={this.state.expandedImageSettings}
                                onChange={(event, expanded) =>
                                    this.setState({
                                        expandedImageSettings: expanded,
                                    })
                                }
                            >
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <Typography>Image Settings</Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <ImageSettings
                                        imageSettings={imageSettings}
                                        selectedImageSettings={
                                            selectedImageSettings
                                        }
                                        selectImageSetting={selectImageSetting}
                                    />
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        )}

                        {videosArray.map((video, index) => (
                            <TextField
                                key={index}
                                margin="dense"
                                id="video_url"
                                label="Video Url"
                                value={video.url || ''}
                                onChange={(event) => {
                                    onUpdateVideoUrlField(
                                        video.id,
                                        event.target.value
                                    );

                                    if (event.target.value.match(urlRegex)) {
                                        this.setState({
                                            errorUrl: false,
                                        });
                                    } else {
                                        this.setState({
                                            errorUrl: true,
                                        });
                                    }

                                    if (event.target.value === '') {
                                        this.setState({
                                            errorUrl: false,
                                        });
                                    }
                                }}
                                type="url"
                                fullWidth
                                error={this.state.errorUrl}
                                helperText={
                                    this.state.errorUrl
                                        ? 'Please fill in a valid url like: www.google.com, https://google.com, http://google.com!'
                                        : 'Type the video URL here'
                                }
                            />
                        ))}

                        {videosArray[0].url !== '' && (
                            <ExpansionPanel
                                style={{marginTop: '10px'}}
                                expanded={this.state.expandedVideoSettings}
                                onChange={(event, expanded) =>
                                    this.setState({
                                        expandedVideoSettings: expanded,
                                    })
                                }
                            >
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <Typography>Video Settings</Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <VideoSettings
                                        videoSettings={videoSettings}
                                        selectedVideoSettings={
                                            selectedVideoSettings
                                        }
                                        selectVideoSetting={selectVideoSetting}
                                    />
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        )}

                        {collapsibleSetting && (
                            <Select
                                style={{marginTop: '10px'}}
                                name="collapsible-select"
                                value={selectedCollapseOptionId}
                                onChange={(selectedOption) =>
                                    selectSectionSetting(
                                        selectedOption,
                                        collapsibleSetting
                                    )
                                }
                                options={collapsibleSetting.options}
                                clearable={false}
                                labelKey={'option'}
                                valueKey={'id'}
                                placeholder="Select Collapsible Type"
                                className="React-select-larger-font"
                            />
                        )}

                        <TextField
                            multiline
                            margin="dense"
                            id="instructions"
                            label="Instructions"
                            onChange={(event) => {
                                onUpdateInstructionsField(event.target.value);
                            }}
                            fullWidth
                            value={instructions}
                        />

                        {isIntro && (
                            <Typography
                                variant="caption"
                                color="error"
                                style={{marginTop: 10}}
                            >
                                *Mandatory fields
                            </Typography>
                        )}
                    </DialogContent>
                    <DialogActions className={classes.dialogActionsBtn}>
                        >
                        <Button
                            onClick={(ev) => {
                                onHandleRequestClose(ev);
                                this.setState({
                                    errorUrl: false,
                                });
                            }}
                            variant="raised"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={(ev) => onHandleRequestDone(ev)}
                            color="primary"
                            variant="raised"
                            disabled={error || this.state.errorUrl}
                        >
                            Done
                        </Button>
                    </DialogActions>
                </EditDialog>

                <ImageDetailsMetaDialog
                    classes={this.props.classes}
                    open={this.state.openImageMetaPopup}
                    imageMeta={this.state.imageMeta}
                    image={this.state.imageToView}
                    setAltField={(alt) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                alt,
                            },
                        });
                    }}
                    setTitleField={(title) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                title,
                            },
                        });
                    }}
                    setDescriptionField={(description) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                description,
                            },
                        });
                    }}
                    setLinkField={(link) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                link,
                            },
                        });
                    }}
                    setNameField={(name) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                name,
                            },
                        });
                    }}
                    handleSubmit={() => {
                        onImageMetaUpdate(
                            this.state.imageMeta,
                            this.state.imageIndex
                        );
                        this.updateState();
                    }}
                    handleCancel={() => {
                        this.updateState();
                    }}
                />

                <ImageDetailsCropDialog
                    cropResult={this.state.cropResult}
                    thumbCropResult={this.state.thumbCropResult}
                    imageToCrop={this.state.imageToCrop}
                    imageRatios={this.props.imageRatios}
                    open={this.state.openCropPopup}
                    imageMeta={this.state.imageMeta}
                    isHero={false}
                    setAltField={(alt) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                alt,
                            },
                        });
                    }}
                    setTitleField={(title) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                title,
                            },
                        });
                    }}
                    setDescriptionField={(description) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                description,
                            },
                        });
                    }}
                    setLinkField={(link) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                link,
                            },
                        });
                    }}
                    setNameField={(name) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                name,
                            },
                        });
                    }}
                    setCropResult={(cropResult) => {
                        this.setState({cropResult});
                    }}
                    setThumbCropResult={(thumbCropResult) => {
                        this.setState({thumbCropResult});
                    }}
                    setCropRatioId={(cropRatioId) => {
                        this.setState({
                            cropRatioId,
                        });
                    }}
                    handleSubmit={() => {
                        if (this.state.cropResult) {
                            let imageObject = b64toBlob(this.state.cropResult);
                            const imageUrlBlob = URL.createObjectURL(
                                imageObject
                            );
                            onCropImage(
                                imageObject,
                                imageUrlBlob,
                                imageObject,
                                this.state.imageIndex
                            );
                        }
                        if (this.state.thumbCropResult) {
                            let thumbImageObject = b64toBlob(
                                this.state.thumbCropResult
                            );
                            const imageThumbUrlBlob = URL.createObjectURL(
                                thumbImageObject
                            );
                            onCropThumbImage(
                                thumbImageObject,
                                imageThumbUrlBlob,
                                thumbImageObject,
                                this.state.imageIndex
                            );
                        }
                        onImageMetaUpdate(
                            this.state.imageMeta,
                            this.state.imageIndex
                        );
                        if (this.state.cropRatioId) {
                            onImageCropRatioUpdate(
                                this.state.cropRatioId,
                                this.state.imageIndex
                            );
                        }
                        this.updateState();
                    }}
                    handleClose={() => {
                        this.updateState();
                    }}
                />
            </div>
        );
    }
}

export default withStyles(styles)(TextSectionEdit);



// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/text_section_edit.js